import APIConnector from "../lib/APIConnector";
import FirebaseConnector from "../lib/FirebaseConnector";
import Settings from "../base/Settings"
const firebaseConnector = new FirebaseConnector({ timeout: 30000 });
const apiConnector = new APIConnector({ timeout: 40000 });

export default class MediaConfig {
    static get APIConnector() {
        return apiConnector;
    }
    static get base() {
        return Settings.SERVER_URL
    }
    /*INIT_INJECT_API_REST_MEDIA_CONFIG*/
    /*END_INJECT_API_REST_MEDIA_CONFIG*/

    static get FirebaseConnector() {
        return firebaseConnector;
    }
}



// WEBPACK FOOTER //
// ./src/provider/media/MediaConfig.js